var _ellipse, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse2, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 157,
    viewBox: "0 0 173 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.5003,
    cy: 81.3828,
    rx: 75,
    ry: 75,
    fill: "#ECF3FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.75 81.3828C160.75 122.39 127.507 155.633 86.5003 155.633C45.4931 155.633 12.2502 122.39 12.2502 81.3828C12.2502 40.3757 45.4931 7.13281 86.5003 7.13281C127.507 7.13281 160.75 40.3757 160.75 81.3828Z",
    stroke: "#AAAAAA",
    strokeOpacity: 0.26,
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 28.9316,
    width: 171,
    height: 105,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 29.4316,
    width: 170,
    height: 104,
    rx: 7.5,
    stroke: "#636363",
    strokeOpacity: 0.41
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48016 33.1379C1.44531 30.7772 2.78129 29.3545 4.99807 29.3545L168.883 29.3545C169.996 29.5771 171.76 30.0164 171.536 33.7519L171.536 40.344C171.536 43.9847 168.197 46.936 164.078 46.936H8.93872C4.81944 46.936 1.4801 43.9847 1.4801 40.344L1.48016 33.1379Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4801 37.7072L171.536 37.7071V46.936H1.4801V37.7072Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.980126 37.2072H0.980101V37.7072V40.344V46.936V47.436H1.4801H8.93872H164.078H171.536H172.036V46.936V40.344V37.7071V37.2071L172.036 33.7668C172.149 31.8367 171.757 30.6401 171.08 29.8987C170.409 29.1635 169.541 28.9761 168.981 28.8642L168.932 28.8545H168.883L4.99807 28.8545C3.78001 28.8545 2.74847 29.2483 2.02905 30.02C1.31359 30.7873 0.962094 31.8689 0.980158 33.1415L0.980126 37.2072Z",
    stroke: "#636363",
    strokeOpacity: 0.41
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46094 38.0345C9.46094 38.772 8.86282 39.3698 8.125 39.3698C7.38718 39.3698 6.78906 38.772 6.78906 38.0345C6.78906 37.2971 7.38718 36.6992 8.125 36.6992C8.86282 36.6992 9.46094 37.2971 9.46094 38.0345Z",
    fill: "#898989"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9141 38.0345C13.9141 38.772 13.3159 39.3698 12.5781 39.3698C11.8403 39.3698 11.2422 38.772 11.2422 38.0345C11.2422 37.2971 11.8403 36.6992 12.5781 36.6992C13.3159 36.6992 13.9141 37.2971 13.9141 38.0345Z",
    fill: "#898989"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 38.0345C18.3672 38.772 17.7691 39.3698 17.0312 39.3698C16.2934 39.3698 15.6953 38.772 15.6953 38.0345C15.6953 37.2971 16.2934 36.6992 17.0312 36.6992C17.7691 36.6992 18.3672 37.2971 18.3672 38.0345Z",
    fill: "#898989"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.168,
    cy: 105.712,
    rx: 10.0195,
    ry: 6.0089,
    fill: "#AAAAAA",
    fillOpacity: 0.63
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0312 79.488C69.3862 76.9629 67.1571 73.9834 64.5477 69.3496C63.1293 66.8307 61.7476 64.071 59.1874 62.7595M76.2578 64.2803C68.7361 69.7 61.6259 75.7949 53.9922 81.0088",
    stroke: "#C1C1C1",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.444 69.061C106.047 72.6791 112.491 80.6102 112.491 80.6102M101.641 81.0085C105.863 76.4823 110.155 72.1915 115.036 68.353C116.078 67.5337 117.176 66.8074 118.117 65.875",
    stroke: "#C1C1C1",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c595dea530109ed152faf0031d52eadb.svg";
export { ForwardRef as ReactComponent };